const ACCESSIBILITY_COMPLIANCE_LINK = 'https://www.tirerack.com/content/tirerack/desktop/en/customer_support/accessibility.html'
const TERMS_OF_USE_COMPLIANCE_LINK = 'https://www.tirerack.com/content/tirerack/desktop/en/customer_support/terms_of_use.html'
const PRIVACY_COMPLIANCE_LINK = 'https://www.tirerack.com/about/privacy.jsp'

export {
  ACCESSIBILITY_COMPLIANCE_LINK,
  TERMS_OF_USE_COMPLIANCE_LINK,
  PRIVACY_COMPLIANCE_LINK
}